<template>
	<div class="customer-reviews-details-group">
		<div
			class="customer-reviews-details-group__wrap"
			:class="{ open: isOpen }"
		>
			<div
				v-for="(value, key, index) in details"
				:key="index + key"
				class="customer-reviews-details-group__item"
			>
				<CustomerReviewsBar
					:value="value"
					:title="key"
					:rating="calculateValue(value)"
				/>
			</div>
		</div>
		<ShowMoreToggle
			v-if="!isMinTablet"
			@show-more-toggle:onToggle="(e) => (isOpen = e)"
		/>
	</div>
</template>

<script lang="ts" setup>
import CustomerReviewsBar from '@lmt-rpb/CustomerReviewsBar/CustomerReviewsBar.vue';
import { type PropType, ref } from 'vue';
import { numberFormat } from '@/js/utils/numberUtils';
import ShowMoreToggle from '@lmt-rpb/Atoms/ShowMoreToggle/ShowMoreToggle.vue';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

const props = defineProps({
	details: {
		type: Object as PropType<Record<string, number>>,
		required: true,
		validator(value: Record<string, number>) {
			return !!Object.keys(value).length;
		},
	},
	maxValue: {
		type: Number,
		required: false,
		default: 6,
	},
});

const isOpen = ref(false);

const { isMinTablet } = storeToRefs(useBreakpointStore());

const calculateValue = (value: number): string => {
	return numberFormat(Math.max(0, Math.min(value, props.maxValue)));
};
</script>

<style lang="scss" scoped>
.customer-reviews-details-group {
	&__wrap {
		display: grid;
		grid-template-columns: 1fr;
		justify-items: center;
		margin: 0;
		max-height: 20.8rem;
		overflow: hidden;
		transition: max-height 0.4s ease-in-out;

		@include media-query-up($breakpoint-small) {
			max-height: 16rem;
			grid-template-columns: repeat(3, 1fr);
			column-gap: 1.6rem;
		}

		&.open {
			max-height: 75rem;
		}
	}

	&__item {
		margin: 0;
		padding: 0.8rem 0;
		width: 100%;
	}
}
</style>
